export const formatCurrency = (value: string | number) => {
  if (typeof value === 'number') {
    value = value.toString();
  } else if (!value) {
    value = '';
  }
  const chars = value.split('').reverse();
  const withCommas = [];
  for (let i = 1, l = chars.length; i <= l; i += 1) {
    withCommas.push(chars[i - 1]);
    if (i % 3 === 0 && i !== chars.length) {
      withCommas.push(',');
    }
  }
  return withCommas.reverse().join('');
};

export const reverseFormatCurrency = (value = '') => {
  return value.replace(/,/gi, '');
};

export const slug = (value: string): string => {
  if (!value) {
    return '';
  }
  return value.toLowerCase().replace(/ /g, '-');
};

export function boolToYesNo(val?: boolean) {
  return val !== undefined ? (val ? 'Yes' : 'No') : '';
}

export function normalizeToFullYear(year: string | null): number {
  const yearNum = Number(year);
  return yearNum < 50 ? 2000 + yearNum : yearNum < 100 ? 1900 + yearNum : yearNum;
}
